import { getNumericValue } from "@brandclub/common-ui";

const BASE_FONT_SIZE = 14;
export const scaleFont = (
  baseFontSize: number | string | undefined = BASE_FONT_SIZE,
  prevFontSize: number
) => {
  const numericBaseFontSize = getNumericValue(baseFontSize);
  if (numericBaseFontSize == null) {
    return prevFontSize;
  }
  return numericBaseFontSize + (prevFontSize - BASE_FONT_SIZE);
};
